export default __webpack_public_path__ + "static/media/info.297b42de.svg";